module.exports = __webpack_public_path__ + "static/media/fcdo-services-logo.f264f781.svg";